import { createSelector } from '@reduxjs/toolkit';
import { getAddressConfig, getBillingStates } from '@yme/components/CheckoutForm/redux/selectors';
const getProfileDataState = ({ profileData }) => profileData;
export const getProfileData = createSelector(getProfileDataState, ({ data }) => ({
    firstName: data?.firstName || '',
    lastName: data?.lastName || '',
    email: data?.email || '',
    phoneNumber: data?.phoneNumber || '',
    username: data?.username || '',
    customAttributes: data?.customAttributes || {
        salutationKey: '',
        salutationLabel: '',
        myYamahaUserId: '',
        countryCode: '',
        driverLicenseCategory: '',
        driverLicenseNumber: '',
    },
    initials: data?.initials,
}));
export const getAuthorizedStatus = createSelector(getProfileDataState, ({ isAuthorized }) => isAuthorized);
export const getProfileMenuData = createSelector(getProfileDataState, ({ profileMenuData }) => profileMenuData);
export const getProfileAddressInfo = createSelector(getProfileDataState, getAddressConfig, getBillingStates, (data, addressConfig, billingStates) => {
    const stateCode = data.data?.customAttributes?.stateCode || '';
    const currentState = addressConfig.states.find((state) => state.code === stateCode) ??
        billingStates
            .flatMap((billingState) => billingState.states)
            .find((state) => state.code === stateCode);
    return {
        city: data.data?.customAttributes?.city || '',
        postalCode: data.data?.customAttributes?.postalCode || '',
        address: data.data?.customAttributes?.street || '',
        country: data.data?.customAttributes?.countryCode || '',
        state: currentState ? `${currentState.code}|${currentState.name}` : '',
    };
});
export const getUserAccountDealerId = createSelector(getProfileDataState, ({ data }) => data?.customAttributes?.userAccountDealerId);
export const getProfileServiceIdsDealer = createSelector(getProfileDataState, ({ profileDealerInfo }) => profileDealerInfo?.serviceIds ?? []);
export const getProfileEmail = createSelector(getProfileDataState, ({ data }) => data?.email || '');
export const getNonCustomerUser = createSelector(getProfileDataState, ({ data }) => Boolean(data?.customAttributes?.isNonCustomerUser));
export const getProfileFiscalCode = createSelector(getProfileDataState, ({ data }) => data?.customAttributes?.fiscalCode);
export const getIsLoadedLogoutIframe = createSelector(getProfileDataState, (profileData) => profileData.isLoadedLogoutIframe);
export const getIsEmptyProfileData = createSelector(getProfileDataState, ({ data }) => !data);
